var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_67042",
    "data-name": "Group 67042",
    transform: "translate(-38.715 -54)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_7_1",
    "data-name": "Component 7 \\u2013 1",
    transform: "translate(38.715 54)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_45",
    "data-name": "Ellipse 45",
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-block",
    "data-name": "Icon material-block",
    d: "M8.144,3a5.144,5.144,0,1,0,5.144,5.144A5.146,5.146,0,0,0,8.144,3ZM4.029,8.144A4.114,4.114,0,0,1,8.144,4.029a4.065,4.065,0,0,1,2.521.869L4.9,10.665A4.065,4.065,0,0,1,4.029,8.144ZM8.144,12.26a4.065,4.065,0,0,1-2.521-.869L11.39,5.624a4.065,4.065,0,0,1,.869,2.521A4.114,4.114,0,0,1,8.144,12.26Z",
    transform: "translate(2.356 2.355)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock);
export default __webpack_public_path__ + "static/media/block.0a52173d2350b4426ba267bf6baa880c.svg";
export { ForwardRef as ReactComponent };